import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateProfileIdentityRequest } from '../../api/update-profile-identity/updateProfileIdentity.types';
import type { UseUpdateProfileIdentityResult } from './useUpdateProfileIdentity.types';

import { updateProfileIdentity } from '../../api/update-profile-identity/updateProfileIdentity';

export function useUpdateProfileIdentity(): UseUpdateProfileIdentityResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateProfileIdentityRequest>({
    mutationFn: updateProfileIdentity,
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({ queryKey: ['client-profiles'] });
    },
  });
}
